import dynamic from 'next/dynamic';

const ExportButton = dynamic(() => import('./ExportButton/ExportButton'));
const ExportAsyncButton = dynamic(() =>
  import('./ExportAsyncButton/ExportAsyncButton')
);
const Switch = dynamic(() => import('./Switch/Switch'));
const ToggleIconButtonsV2 = dynamic(() =>
  import('./ToggleIconButtonsV2/ToggleIconButtonsV2')
);
const ExpandedItem = dynamic(() => import('./ExpandedItem/ExpandedItem'));
const SimpleMenu = dynamic(() => import('./SimpleMenu/SimpleMenu'));
const DrawerMenu = dynamic(() => import('./DrawerMenu/DrawerMenu'));
const Logo = dynamic(() => import('./Logo/Logo'));
const NoAccess = dynamic(() => import('./NoAccess/NoAccess'));
const ToggleButton = dynamic(() => import('./ToggleButtons/ToggleButtons'));
const Clipboard = dynamic(() => import('./Clipboard/Clipboard'));
const Accordion = dynamic(() => import('./Accordion/Accordion'));
const StageChip = dynamic(() => import('./StageChip/StageChip'));
const Block = dynamic(() => import('./Block/Block'));
const Link = dynamic(() => import('./Link/Link'));
const SubTitle = dynamic(() => import('./SubTitle/SubTitle'));
const IconButtonV2 = dynamic(() => import('./IconButtonV2/IconButtonV2'));
const Loader = dynamic(() => import('./Loader/Loader'));
const ButtonV2 = dynamic(() => import('./ButtonV2/ButtonV2'));
const HelperText = dynamic(() => import('./HelperText'));
const Title = dynamic(() => import('./Title/Title'));
const Text = dynamic(() => import('./Text/Text'));
const OverflowTooltip = dynamic(() =>
  import('./OverflowTooltip/OverflowTooltip')
);
const CardInfo = dynamic(() => import('./CardInfo/CardInfo'));

export { PopoverColorPicker } from './PopoverColorPicker';
export * from './Vectors';
export {
  ExportButton,
  ExportAsyncButton,
  Switch,
  ToggleIconButtonsV2,
  ExpandedItem,
  SimpleMenu,
  DrawerMenu,
  Logo,
  NoAccess,
  ToggleButton,
  Clipboard,
  Accordion,
  StageChip,
  Block,
  Link,
  SubTitle,
  IconButtonV2,
  Loader,
  ButtonV2,
  HelperText,
  Title,
  Text,
  OverflowTooltip,
  CardInfo,
};
